import React, { useEffect } from 'react';
import useBranding from './branding/useBranding';
import { isNewUi } from './uiMode';
import { ensureFonts } from './fonts';
import './loginCard.css';

// Signed-out pages (login, password change, ERP logout notice, LoginError, Maintenance, Error) in the new UI: the same
// components and behaviour, restyled by redesign.css under .apw2-auth. Classic renders them unwrapped.
const FIELD_NAMES = { confirmPassword: 'Confirm password', cboCompany: 'Company', cboUserRole: 'Role' };

export default function AuthFrame({ children }) {
	const on = isNewUi();
	useBranding(on);
	useEffect(() => {
		if (!on) return undefined;
		ensureFonts();
		document.body.classList.add('apw2-auth-on');
		return () => document.body.classList.remove('apw2-auth-on');
	}, [on]);
	// The centered sign-in card shows a label above each field (redesign.css); give the fields the same names for
	// screen readers. Classic's inputs have none. A field that already has a name keeps it.
	useEffect(() => {
		if (!on) return undefined;
		const name = () => Object.entries(FIELD_NAMES).forEach(([id, label]) => {
			const el = document.getElementById(id);
			if (el && !el.getAttribute('aria-label')) el.setAttribute('aria-label', label);
		});
		name();
		const obs = new MutationObserver(name);
		obs.observe(document.body, { childList: true, subtree: true });
		return () => obs.disconnect();
	}, [on]);
	return on ? <div className="apw2 apw2-auth">{children}</div> : children;
}
